import React from 'react';

import { IconButton } from '@mui/material';

import PauseIcon from './assets/pause.svg';
import PlayIcon from './assets/play.svg';
import useStyles from './styles';

interface Props {
    state: 'playing' | 'paused';
    onClick?: () => void;
    className?: string;
}

const PlayButton: React.FC<Props> = ({ state, onClick, className }) => {
    const { classes, cx } = useStyles();

    return (
        <IconButton className={cx(classes.root, className)} onClick={onClick}>
            {state === 'playing' ? <PauseIcon /> : state === 'paused' ? <PlayIcon /> : null}
        </IconButton>
    );
};
export default PlayButton;
